module.exports = __webpack_public_path__ + "img/189.d17ecdfa.jpg";